import $ from "jquery"

$(function () {
  $(document).on("scroll", function () {
    var $nav = $(".boot-nav.main")
    $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height())
  })
})
